<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 py3 mb2">
      <div class="xs-col-12 sm-col-12 md-col-7 lg-col-7 px2">
        <div class="clearfix border muted-border p2 py3 shadow">
          <div class="col-12 px2">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Henvis en håndværker</p>
            <p class="h5 regular darkblue line-height-golden mt1 mb3">
              <span class="primarycolor block semi-bold">Sharing is caring</span>
              Er du glad for din Håndværker.dk-løsning? Hvorfor ikke dele glæden med en ven :-)<br><br>
              Når du har henvist en håndværker, som bliver kunde ved Håndværker.dk,
              så får I begge en måneds gratis abonnement. 
            </p>
            <div class="flex justify-start items-stretch my3">
              <b-img src="static/img/photo3.png" fluid-grow></b-img>
            </div>
            <p class="h5 regular darkblue line-height-golden mt1 mb3">
              For at få fordelen skal du efter aftale med den håndværker du henviser, give os deres informationer herunder. Så tager vi kontakt til dem. 
            </p>
          </div>
          <form action="">
            <div class="clearfix mb2">
              <div class="flex flex-column px2">
                <p class="h6 darkblue gibson line-height-1 mb1">Navn</p>
                <b-form-input class="muted-background darkblue gibson h5 regular border-none not-rounded" type="text" required></b-form-input>
              </div>
            </div>
            <div class="clearfix mb2">
              <div class="flex flex-column px2">
                <p class="h6 darkblue gibson line-height-1 mb1">Email</p>
                <b-form-input class="muted-background darkblue gibson h5 regular border-none not-rounded" type="text" required></b-form-input>
              </div>
            </div>
            <div class="clearfix mb2">
              <div class="flex flex-column px2">
                <p class="h6 darkblue gibson line-height-1 mb1">Mobil</p>
                <b-form-input class="muted-background darkblue gibson h5 regular border-none not-rounded" type="text" required></b-form-input>
              </div>
            </div>
            <div class="clearfix px2">
              <button class="col-12 action-button p2 h4 flex justify-center items-center gibson line-height-1">
                <span class="semi-bold">Send</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </form>
          <haandvaerker></haandvaerker>
        </div>
      </div>
    </div>
    <div class="py3"></div>
  </div>
</template>
<script>
import haandvaerker from './haandvaerker'
export default {
  components: {
    haandvaerker
  },
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// InviterKollega.vue?9e6e0412